module.exports = __webpack_public_path__ + "img/69.33ddc697.png";